import schedule from '@/api/schedule'

const state = {
  pendingReminders: [],
  completedReminders: [],
  totalPendingReminders: 0,
  totalCompletedReminders: 0
}

const getters = {}

const mutations = {
  SET_PENDING_REMINDERS(state, data) {
    state.pendingReminders = data.results
    state.totalPendingReminders = data.count
  },
  SET_COMPLETED_REMINDERS(state, data) {
    state.completedReminders = data.results
    state.totalCompletedReminders = data.count
  }
}

const actions = {
  async getReminderList({ commit }, params) {
    try {
      const response = await schedule.getReminderList(params)
      if (params.status === 'pending') {
        commit('SET_PENDING_REMINDERS', response.data)
      } else {
        commit('SET_COMPLETED_REMINDERS', response.data)
      }
      return response.data
    } catch (error) {
      throw error
    }
  },

  async stopReminder({ dispatch }, reminderId) {
    try {
      await schedule.stopReminder(reminderId)
      // 一覧を再取得
      dispatch('getReminderList', { status: 'pending', page: 1, per_page: 50 })
    } catch (error) {
      throw error
    }
  },

  async deleteReminder({ dispatch }, reminderId) {
    try {
      await schedule.deleteReminder(reminderId)
      // 両方の一覧を再取得
      dispatch('getReminderList', { status: 'pending', page: 1, per_page: 50 })
      dispatch('getReminderList', { status: 'completed', page: 1, per_page: 50 })
    } catch (error) {
      throw error
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/schedule.js